import BetaLargeBadge from 'assets/img/beta_badge_large.png'
import YoloCoinFlipImg from 'assets/img/yolo-coin_flip.png'
import GamePageScreenDesktop from 'assets/img/yolorekt_game_1-desktop.png'
import GamePageScreenMobile from 'assets/img/yolorekt_game_1-mobile.png'
import YoloTokenImg from 'assets/img/yolo_token_image_2.png'
import EmailSendImg from 'assets/img/email_up.png'
import HomePageBgImg from 'assets/img/home_main_bg-dark-glitter-2.jpg'
import HomePageBgImg2 from 'assets/img/game_dark_bg.jpg'
import HomePageBgImgBlur from 'assets/img/game_dark_bg.jpg'
import ReferralContestBgImg from 'assets/img/referral_contest_background.jpg'
import LightPapterBg from 'assets/img/litepaper_bg.jpg'
import AssetGraphImg from 'assets/img/asset_graph-eth.png'
import BullImg from 'assets/img/bull.png'
import BearImg from 'assets/img/bear.png'
import CircleLogoBigImg from 'assets/img/cicle_logo_big.png'
import DualIssuanceImg from 'assets/img/dual_issuance.png'
import FireFoxMenuBg from 'assets/img/firefox_menu_bg.jpg'
import YoloRocket from 'assets/img/yolo_rocket.png'
import ProjectGalaxySteps from 'assets/img/project_galaxy_steps_v2.svg'
import ProjectGalaxyStepsMobile1 from 'assets/img/project_galaxy_steps-mobile-1.svg'
import ProjectGalaxyStepsMobile2 from 'assets/img/project_galaxy_steps-mobile-2.svg'
import signin_bg from 'assets/img/signin_bg.jpg'
import games_menu_day_ss from 'assets/img/games_menu_day_ss.jpg'
import twoX_deposit_bonus from 'assets/img/2x_deposit_bonus.jpg'
import three_row_contest_bg from 'assets/img/3_row_contest_bg.jpg'
import temp_live_asset_graph_small from 'assets/img/temp_live_asset_graph-small.png'
import temp_24hr_graph_small from 'assets/img/temp_24hr_graph-small.png'
import profile_photo_temp from 'assets/img/profile_photo_temp.jpg'
import bg_landing_slide_1 from 'assets/img/bg_landing_slide_1.jpg'
import iws_banner_bg from 'assets/img/iws_banner_bg.jpg'
import win_infinite_icon from 'assets/img/win_infinite_icon.png'
import stpp_banner_bg from 'assets/img/stpp_banner_bg.png'
import yd_banner_bg from 'assets/img/yd_banner_bg.jpg'
import bg_landing_slide_2 from 'assets/img/bg_landing_slide_2.jpg'
import futures_stocks_slide_bg_3 from 'assets/img/futures_stocks_slide_bg_3.jpg'
import futures_stocks_image_2 from 'assets/img/futures_stocks_image_2.png'
import futures_rewards_pool_bg from 'assets/img/futures_rewards_pool_bg.jpg'
import wsb_banner from 'assets/img/wsb_banner.png'
import leveraged_gaming_feature_title from 'assets/img/leveraged_gaming_feature_title.png'
import leveraged_gaming_bg from 'assets/img/leveraged_gaming_bg.jpg'
import leveraged_gaming_bg_new from 'assets/img/leveraged_gaming_bg-new.jpg'
import yolo_token_bg_2 from 'assets/img/yolo_token_bg_2.jpg'
import wl_circles from 'assets/img/wl_circles.png'
import BUSTED_end_of_round from 'assets/img/BUSTED_end-of-round.svg'

export const images = {
  GamePageScreenDesktop,
  GamePageScreenMobile,
  YoloTokenImg,
  EmailSendImg,
  HomePageBgImg,
  HomePageBgImg2,
  HomePageBgImgBlur,
  ReferralContestBgImg,
  BullImg,
  BearImg,
  FireFoxMenuBg,
  CircleLogoBigImg,
  DualIssuanceImg,
  LightPapterBg,
  AssetGraphImg,
  BetaLargeBadge,
  YoloCoinFlipImg,
  YoloRocket,
  ProjectGalaxySteps,
  ProjectGalaxyStepsMobile1,
  ProjectGalaxyStepsMobile2,
  signin_bg,
  games_menu_day_ss,
  twoX_deposit_bonus,
  three_row_contest_bg,
  temp_live_asset_graph_small,
  temp_24hr_graph_small,
  profile_photo_temp,
  bg_landing_slide_1,
  iws_banner_bg,
  win_infinite_icon,
  stpp_banner_bg,
  yd_banner_bg,
  bg_landing_slide_2,
  futures_stocks_slide_bg_3,
  futures_stocks_image_2,
  futures_rewards_pool_bg,
  wsb_banner,
  leveraged_gaming_bg,
  leveraged_gaming_bg_new,
  leveraged_gaming_feature_title,
  yolo_token_bg_2,
  wl_circles,
  BUSTED_end_of_round,
}
